;(function(){
  'use strict';
  if(window.__SHAliReviewsProductSyncV110)return;
  window.__SHAliReviewsProductSyncV110=true;

  var DATA_ID='SHProductReviewDataV110';
  var SUMMARY_SELECTOR='.sh-studio .sh-buy-summary';
  var REVIEW_SELECTOR='.buy__meta[data-sh-scroll-reviews]';

  function readData(){
    var node=document.getElementById(DATA_ID);
    if(!node)return null;
    try{return JSON.parse(node.textContent||'{}');}catch(error){return null;}
  }

  function normalise(value){
    var number=Number(value);
    return Number.isFinite(number)?number:0;
  }

  function validRating(rating,count){
    return rating>0&&rating<=5&&count>0;
  }

  function formatCount(count){
    var rounded=Math.max(0,Math.round(count));
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-GB').format(rounded);}catch(error){return String(rounded);}
  }

  function buildButton(summary){
    var button=document.createElement('button');
    button.type='button';
    button.className='buy__meta';
    button.setAttribute('data-sh-scroll-reviews','');
    var anchor=summary.querySelector('.buy__subtext')||summary.querySelector('h1');
    if(anchor)anchor.insertAdjacentElement('afterend',button);
    else summary.insertBefore(button,summary.firstChild);
    return button;
  }

  function render(){
    var data=readData();
    if(!data)return false;

    var aliRating=normalise(data.aliRating);
    var aliCount=normalise(data.aliCount);
    var fallbackRating=normalise(data.fallbackRating);
    var fallbackCount=normalise(data.fallbackCount);
    var rating=aliRating;
    var count=aliCount;
    var source='alireviews';

    if(!validRating(rating,count)){
      rating=fallbackRating;
      count=fallbackCount;
      source='sickhaus-fallback';
    }
    if(!validRating(rating,count))return false;

    var summary=document.querySelector(SUMMARY_SELECTOR);
    if(!summary)return false;

    var button=summary.querySelector(REVIEW_SELECTOR)||buildButton(summary);
    var ratingText=(Math.round(rating*10)/10).toFixed(1);
    var countText=formatCount(count);
    var label=Math.round(count)===1?'review':'reviews';

    button.innerHTML='<span class="stars" aria-hidden="true">★★★★★</span><span><b class="num">'+ratingText+'</b> · <span class="num">'+countText+'</span> '+label+'</span>';
    button.setAttribute('aria-label','Rated '+ratingText+' out of 5 from '+countText+' product '+label+' — view product reviews');
    button.setAttribute('data-sh-review-source',source);
    return true;
  }

  function prepare(){
    if(render())return;
    var attempts=0;
    var timer=window.setInterval(function(){
      attempts+=1;
      if(render()||attempts>=20)window.clearInterval(timer);
    },150);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',prepare,{once:true});
  else prepare();
  window.addEventListener('pageshow',function(){window.setTimeout(render,0);});
  document.addEventListener('shopify:section:load',function(){window.setTimeout(render,0);});
})();
